import { SVGProps } from 'react'

export const AddPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <rect width="16" height="16" fill="#3A79E0" rx="4"></rect>
    <path
      fill="#fff"
      d="M9.5 8a2 2 0 10.001-3.999A2 2 0 009.5 8zM5 7V6c0-.275-.225-.5-.5-.5S4 5.725 4 6v1H3c-.275 0-.5.225-.5.5s.225.5.5.5h1v1c0 .275.225.5.5.5S5 9.275 5 9V8h1c.275 0 .5-.225.5-.5S6.275 7 6 7H5zm4.5 2c-1.335 0-4 .67-4 2v.5c0 .275.225.5.5.5h7c.275 0 .5-.225.5-.5V11c0-1.33-2.665-2-4-2z"
    ></path>
  </svg>
)
